import { render, staticRenderFns } from "./AccordionListInsertItem.vue?vue&type=template&id=82c38914&scoped=true"
import script from "./AccordionListInsertItem.vue?vue&type=script&lang=js"
export * from "./AccordionListInsertItem.vue?vue&type=script&lang=js"
import style0 from "./AccordionListInsertItem.vue?vue&type=style&index=0&id=82c38914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c38914",
  null
  
)

export default component.exports